// extracted by mini-css-extract-plugin
export default {"btn":"Nav_btn__tyjCg","nav":"Nav_nav__iMr2i","active":"Nav_active__IBB1P","link":"Nav_link__EL7QY"};